import { ProjectRole } from '../project/project.schema'

export const PortfolioRole = {
  ...ProjectRole,
} as const
